<h2 mat-dialog-title>{{title}}</h2>

<mat-dialog-content>

    <p>{{confirmationText}}</p>

</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">

  <button mat-raised-button
          (click)="cancel()">

     @if(leftButtonText) {
       {{leftButtonText}}
     } @else {
       {{ "common.no" | translate }}
     }

  </button>

  <button mat-raised-button color="primary"
          (click)="confirm()">

    @if(rightButtonText) {

      {{rightButtonText}}

    } @else {

      {{ "common.yes" | translate }}

    }

  </button>

</mat-dialog-actions>


